// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"6ef7d95a","159":"ee80d827","200":"fecfc8ac","495":"d4b2c2ea","655":"7c880880","699":"8f0931fe","883":"855b663e","942":"1c6c51c2"}[chunkId] + ".chunk.js";
};